import React from 'react';

export const MTLogo = ({ className = "w-10 h-10" }: { className?: string }) => (
  <svg viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <rect width="40" height="40" rx="10" fill="#000000" />
    <rect x="0.5" y="0.5" width="39" height="39" rx="9.5" stroke="#262626" strokeWidth="1" />
    {/* M */}
    <path d="M10 28V14L16 21L22 14V28" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    {/* T */}
    <path d="M24 14H32" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
    <path d="M28 14V28" stroke="white" strokeWidth="2.5" strokeLinecap="round"/>
  </svg>
);
